import Vue from 'vue';
import VueRouter from 'vue-router';
import Promise from 'promise-polyfill';
import TicketWidgetHelper from './TicketWidgetHelper';
import Resources from 'designmynight-javascript-sdk/src/Integrations/vue.js';
import AppSize from './services/ResponsiveContainer';
import VueCurrencyFilter from 'vue-currency-filter/VueCurrencyFilter.js';
import VueScrollTo from 'vue-scrollto';
import VueGtag from "vue-gtag";

// import bugsnag from '@bugsnag/js'
// import bugsnagVue from '@bugsnag/plugin-vue'

// const bugsnagClient = bugsnag({
//     apiKey: 'dbdbe46145c6a1306644cb4508170715',
//     releaseStage: NODE_ENV
// });

// bugsnagClient.use(bugsnagVue, Vue)

function bootstrap() {
    // To add to window
    if (!window.Promise) {
        window.Promise = Promise;
    }

    Vue.use(VueRouter);
    Vue.use(Resources);
    Vue.use(AppSize);
    Vue.use(VueCurrencyFilter, {symbol: '£', thousandsSeparator: ','})
    Vue.use(VueScrollTo);

    Vue.config.productionTip = false;

    window.DMN = window.DMN || {};

    if (!window.DMN.TicketWidgetHelper) {
        window.DMN.TicketWidgetHelper = new TicketWidgetHelper();
    }

    window.DMN.TicketWidgetHelper.findTicketWidgetScriptTags();
}

export { bootstrap };